import React, { useEffect, useState } from "react";
import { Layout } from "../../../layout";
import CustomLink from "../../components/hoverlink";

interface NewsItem {
  title: string;
  link: string;
}
interface Feed {
  source: string;
  items: NewsItem[];
}

const TopNews: React.FC = () => {
  const [feeds, setFeeds] = useState<Feed[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [lastUpdated, setLastUpdated] = useState<string | null>(null);

  const getNews = async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await fetch("/.netlify/functions/fetch-news");
      if (!res.ok) throw new Error("Fetch failed");
      const data = await res.json();
      setFeeds(data.results || []);
      setLastUpdated(data.updated);
    } catch (err) {
      console.error("Error fetching news:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNews();
  }, []);

  return (
    <Layout title="Top News">
      <div style={{ backgroundColor: "#000", minHeight: "100vh" }}>
        <div
          style={{
            color: "#ddd",
            padding: "40px",
            fontFamily: "monospace",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <h1
              style={{
                color: "#fff",
                fontSize: "26px",
                marginBottom: "20px",
                marginTop: 0,
              }}
            >
              TOP NEWS
            </h1>
            <button
              onClick={getNews}
              disabled={loading}
              style={{
                backgroundColor: "#ff8c1a",
                border: "none",
                color: "#000",
                fontWeight: "bold",
                padding: "8px 14px",
                borderRadius: "4px",
                cursor: "pointer",
                opacity: loading ? 0.6 : 1,
                transition: "opacity 0.3s",
              }}
            >
              🔄 {loading ? "Refreshing..." : "Refresh Headlines"}
            </button>
          </div>

          {lastUpdated && (
            <p
              style={{ color: "#777", fontSize: "12px", marginBottom: "20px" }}
            >
              Last updated: {new Date(lastUpdated).toLocaleTimeString()}
            </p>
          )}

          {loading && !feeds.length && (
            <p style={{ color: "#999" }}>Fetching latest headlines...</p>
          )}

          {error && (
            <p style={{ color: "red", marginTop: "10px" }}>
              Failed to load news. Please try refreshing.
            </p>
          )}

          {!loading && !error && feeds.length > 0 && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "40px",
                marginTop: "20px",
              }}
            >
              {feeds.map((feed, i) => (
                <div key={i}>
                  <h2
                    style={{
                      color: "#fff",
                      fontSize: "18px",
                      borderBottom: "1px solid #333",
                      paddingBottom: "6px",
                      marginBottom: "10px",
                      textTransform: "capitalize",
                    }}
                  >
                    {feed.source.replace(/^\w/, (c) => c.toUpperCase())}
                  </h2>
                  <ol style={{ paddingLeft: "20px", margin: 0 }}>
                    {feed.items.map((item, j) => (
                      <li
                        key={j}
                        style={{
                          marginBottom: "6px",
                          listStyle: "decimal",
                          color: "#ff8c1a",
                        }}
                      >
                        <CustomLink
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span style={{ color: "#ff8c1a" }}>{item.title}</span>
                        </CustomLink>
                      </li>
                    ))}
                  </ol>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default TopNews;
